import { useEffect } from 'react';
import urlTemplate from 'url-template';
import { useAxios } from 'src/hooks/use-axios';
import { setLocationHref } from 'src/utils/location-usage';

export const JOB_RUN_DOWNLOAD_URL = `${PRISMA_CONFIG.transparencyReporting}/job-runs/{id}/download-s3`;

type HookConfig = {
  jobRunDownloadUrl: string;
};

type ExecuteProps = {
  id: number;
};

export function useJobRunDownload({ jobRunDownloadUrl }: HookConfig) {
  const request = useAxios(
    (axios, baseConfig, { id }: ExecuteProps) => {
      const url = urlTemplate.parse(jobRunDownloadUrl).expand({ id });

      return axios.request<string>({
        ...baseConfig,
        url,
        responseType: 'text',
      });
    },
    { neededOnPageLoad: false }
  );

  useEffect(() => {
    if (!request.response) return;

    setLocationHref(request.response.data);
  }, [request.response]);

  return request;
}

export type JobRunDownloadRequest = ReturnType<typeof useJobRunDownload>;
